import { call, put, takeEvery } from 'redux-saga/effects';
import download from 'downloadjs';
import callApi from 'utils/callApi';
import { addPatientResource } from 'redux/modules/patients';
import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';

// Actions
export const CREATE_PATIENT_DOCUMENT = 'CREATE_PATIENT_DOCUMENT';
export const CREATE_PATIENT_DOCUMENT_SUCCESS = 'CREATE_PATIENT_DOCUMENT_SUCCESS';
export const CREATE_PATIENT_DOCUMENT_FAIL = 'CREATE_PATIENT_DOCUMENT_FAIL';
export const DELETE_PATIENT_DOCUMENT = 'DELETE_PATIENT_DOCUMENT';
export const DELETE_PATIENT_DOCUMENT_SUCCESS = 'DELETE_PATIENT_DOCUMENT_SUCCESS';
export const DELETE_PATIENT_DOCUMENT_FAIL = 'DELETE_PATIENT_DOCUMENT_FAIL';
export const DOWNLOAD_PATIENT_DOCUMENT = 'DOWNLOAD_PATIENT_DOCUMENT';
export const DOWNLOAD_PATIENT_DOCUMENT_SUCCESS = 'DOWNLOAD_PATIENT_DOCUMENT_SUCCESS';
export const DOWNLOAD_PATIENT_DOCUMENT_FAIL = 'DOWNLOAD_PATIENT_DOCUMENT_FAIL';
export const ADD_PATIENT_DOCUMENT_RESOURCE = 'ADD_PATIENT_DOCUMENT_RESOURCE';
export const ADD_PATIENT_DOCUMENT_RESOURCE_SUCCESS = 'ADD_PATIENT_DOCUMENT_RESOURCE_SUCCESS';
export const ADD_PATIENT_DOCUMENT_RESOURCE_FAIL = 'ADD_PATIENT_DOCUMENT_RESOURCE_FAIL';
export const REMOVE_PATIENT_DOCUMENT_RESOURCE = 'REMOVE_PATIENT_DOCUMENT_RESOURCE';
export const REMOVE_PATIENT_DOCUMENT_RESOURCE_SUCCESS = 'REMOVE_PATIENT_DOCUMENT_RESOURCE_SUCCESS';
export const REMOVE_PATIENT_DOCUMENT_RESOURCE_FAIL = 'REMOVE_PATIENT_DOCUMENT_RESOURCE_FAIL';
export const GET_PATIENT_DOCUMENT = 'GET_PATIENT_DOCUMENT';
export const GET_PATIENT_DOCUMENT_SUCCESS = 'GET_PATIENT_DOCUMENT_SUCCESS';
export const GET_PATIENT_DOCUMENT_FAIL = 'GET_PATIENT_DOCUMENT_FAIL';

// Reducer
export default function patientsDocumentsReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type, payload } = action;
  switch (type) {
    case CREATE_PATIENT_DOCUMENT_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (!payload['Record Number'] || dataItem['Record Number'] !== payload['Record Number']) {
          return dataItem;
        }
        const newDocuments = [
          ...payload.Documents,
          ...dataItem.Documents,
        ];
        return {
          ...dataItem,
          Documents: newDocuments,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case ADD_PATIENT_DOCUMENT_RESOURCE_SUCCESS:
    case REMOVE_PATIENT_DOCUMENT_RESOURCE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem.Documents || dataItem.Documents.length === 0) {
          return dataItem;
        }

        const newDocuments = dataItem.Documents.map((documentsItem) => {
          if (documentsItem.ID !== payload.ID) {
            return documentsItem;
          }

          return {
            ...documentsItem,
            ...payload,
          };
        });

        return {
          ...dataItem,
          Documents: newDocuments,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_PATIENT_DOCUMENT_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem['Record Number'] !== payload['Record Number']) {
          return dataItem;
        }
        const index = dataItem.Documents.findIndex(item => item.ID === payload.ID);
        const newDocuments = [
          ...dataItem.Documents.slice(0, index),
          ...dataItem.Documents.slice(index + 1),
        ];
        return {
          ...dataItem,
          Documents: newDocuments,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export function createPatientDocument(payload) {
  return { type: CREATE_PATIENT_DOCUMENT, payload };
}

export function createPatientDocumentSuccess(payload) {
  return { type: CREATE_PATIENT_DOCUMENT_SUCCESS, payload };
}

export function createPatientDocumentFail(payload) {
  return { type: CREATE_PATIENT_DOCUMENT_FAIL, payload };
}

export function deletePatientDocument(payload) {
  return { type: DELETE_PATIENT_DOCUMENT, payload };
}

export function deletePatientDocumentSuccess(payload) {
  return { type: DELETE_PATIENT_DOCUMENT_SUCCESS, payload };
}

export function deletePatientDocumentFail(payload) {
  return { type: DELETE_PATIENT_DOCUMENT_FAIL, payload };
}

export function downloadPatientDocument(payload) {
  return { type: DOWNLOAD_PATIENT_DOCUMENT, payload };
}

export function downloadPatientDocumentSuccess(payload) {
  return { type: DOWNLOAD_PATIENT_DOCUMENT_SUCCESS, payload };
}

export function downloadPatientDocumentFail(payload) {
  return { type: DOWNLOAD_PATIENT_DOCUMENT_FAIL, payload };
}

export function addPatientDocumentResource(payload) {
  return { type: ADD_PATIENT_DOCUMENT_RESOURCE, payload };
}

export function addPatientDocumentResourceSuccess(payload) {
  return { type: ADD_PATIENT_DOCUMENT_RESOURCE_SUCCESS, payload };
}

export function addPatientDocumentResourceFail(payload) {
  return { type: ADD_PATIENT_DOCUMENT_RESOURCE_FAIL, payload };
}

export function removePatientDocumentResource(payload) {
  return { type: REMOVE_PATIENT_DOCUMENT_RESOURCE, payload };
}

export function removePatientDocumentResourceSuccess(payload) {
  return { type: REMOVE_PATIENT_DOCUMENT_RESOURCE_SUCCESS, payload };
}

export function removePatientDocumentResourceFail(payload) {
  return { type: REMOVE_PATIENT_DOCUMENT_RESOURCE_FAIL, payload };
}

export function getPatientDocument(payload) {
  return { type: GET_PATIENT_DOCUMENT, payload };
}

export function getPatientDocumentSuccess(payload) {
  return { type: GET_PATIENT_DOCUMENT_SUCCESS, payload };
}

export function getPatientDocumentFail(payload) {
  return { type: GET_PATIENT_DOCUMENT_FAIL, payload };
}

// Requests
export function requestCreatePatientDocument(payload) {
  return callApi('patient/document/', 'POST', payload, false);
}

export function requestDeletePatientDocument(payload) {
  return callApi(`patient/document/?id=${payload}`, 'DELETE');
}

export function requestAddPatientDocumentResource(payload) {
  return callApi('patient/document/change_resource/add/', 'POST', payload);
}

export function requestRemovePatientDocumentResource(payload) {
  return callApi('patient/document/change_resource/remove/', 'POST', payload);
}

export function requestDownloadPatientDocument({ href }) {
  return download(href);
}

export function requestGetPatientDocument(payload) {
  return callApi(`patient/document/?id=${payload}`);
}

// Sagas
function* createPatientDocumentSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const formData = new FormData();
    formData.append('object_id', values['Record Number']);
    if (values.Name) {
      formData.append('file', values.Document, values.Name);
    } else {
      formData.append('file', values.Document);
    }
    const res = yield call(requestCreatePatientDocument, formData);
    yield put(addPatientResource({
      'Record Number': values['Record Number'],
      'Document ID': [res.data.ID],
    }));
    yield put(createPatientDocumentSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createPatientDocumentFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* deletePatientDocumentSaga(action) {
  try {
    const res = yield call(requestDeletePatientDocument, action.payload.ID);
    yield put(deletePatientDocumentSuccess(action.payload));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(deletePatientDocumentFail(err.data));
  }
}

function* downloadPatientDocumentSaga(action) {
  try {
    yield call(requestDownloadPatientDocument, action.payload);
    yield put(downloadPatientDocumentSuccess());
  } catch (err) {
    yield put(downloadPatientDocumentFail());
  }
}

function* addPatientDocumentResourceSaga(action) {
  const {
    resolve,
    reject,
    values,
  } = action.payload;
  try {
    const res = yield call(requestAddPatientDocumentResource, values);
    yield put(addPatientDocumentResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(addPatientDocumentResourceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* removePatientDocumentResourceSaga(action) {
  const {
    resolve,
    reject,
    values,
  } = action.payload;
  try {
    const res = yield call(requestRemovePatientDocumentResource, values);
    yield put(removePatientDocumentResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(removePatientDocumentResourceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* getPatientDocumentSaga(action) {
  try {
    const res = yield call(requestGetPatientDocument, action.payload.ID);
    yield put(getPatientDocumentSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(getPatientDocumentFail(err.data));
  }
}

export function* patientsDocumentsSaga() {
  yield takeEvery(CREATE_PATIENT_DOCUMENT, createPatientDocumentSaga);
  yield takeEvery(DELETE_PATIENT_DOCUMENT, deletePatientDocumentSaga);
  yield takeEvery(DOWNLOAD_PATIENT_DOCUMENT, downloadPatientDocumentSaga);
  yield takeEvery(ADD_PATIENT_DOCUMENT_RESOURCE, addPatientDocumentResourceSaga);
  yield takeEvery(REMOVE_PATIENT_DOCUMENT_RESOURCE, removePatientDocumentResourceSaga);
  yield takeEvery(GET_PATIENT_DOCUMENT, getPatientDocumentSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/patientsDocuments.js